import React from 'react';

class THead extends React.Component {
    render() {
        const dataColumns = this.props.columns;
        const tableHeaders = (
            <tr>
                {dataColumns.map(function (column, index) {
                    return <th className={column.class == undefined ? '' : column.class} scope="col" key={index} hidden= {column.hidden == undefined ? false : column.hidden }>{column.title}</th>;
                })}
            </tr>);

        if (dataColumns.length == 0 ){
            return null;
        }
        return (
                <thead>
                    {tableHeaders}
               </thead>
        )
    }
};
export default THead; 